import React, { useState } from 'react';
import { Badge, Button, Form } from 'react-bootstrap';
import {
  storeChoices,
  activeStoreCount,
  groupStores
} from '../lib/storeHelpers';
import HelpTip from './HelpTip';
import BrandIcon from './BrandIcon';
import { marketplaceIconFor } from '../config/brandIcons';
let sequence = 0;
const StoreChecklist = ({
  stores,
  value = [],
  onChange,
  disabled,
  multiple = true
}) => {
  const [search, setSearch] = useState('');
  const [selectedOnly, setSelectedOnly] = useState(false);
  const [id] = useState(() => `rate-shop-stores-${++sequence}`);
  const selected = Array.isArray(value) ? value : value ? [value] : [];
  const choices = storeChoices(stores, selected);
  const count = activeStoreCount(stores, selected);
  const visible = choices.filter(
    s =>
      (!selectedOnly || selected.includes(s.id)) &&
      `${s.label} ${s.companyName} ${s.marketplaceName || ''}`
        .toLowerCase()
        .includes(search.toLowerCase())
  );
  const groups = groupStores(visible, selected);
  const change = ids => onChange(multiple ? ids : ids[0] || '');
  return (
    <div className="border rounded p-3">
      <Form.Label htmlFor={`${id}-search`}>
        Find a store{' '}
        <HelpTip label="Find a store">
          Search by store name, marketplace or company.
        </HelpTip>
      </Form.Label>
      <Form.Control
        id={`${id}-search`}
        className="mb-2"
        placeholder="Search stores…"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <p className="small text-muted mb-2">
        {count.selected} of {count.total} active stores selected
        <Button
          type="button"
          size="sm"
          className="ms-2 rounded-pill"
          variant={selectedOnly ? 'primary' : 'outline-secondary'}
          aria-pressed={selectedOnly}
          onClick={() => setSelectedOnly(!selectedOnly)}
        >
          Selected only
        </Button>
      </p>
      <div style={{ maxHeight: 280, overflowY: 'auto' }}>
        {groups.map(([company, rows]) => (
          <div key={company} className="mb-3">
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-1">
              <strong className="small">{company}</strong>
              {multiple && (
                <span>
                  <Button
                    type="button"
                    variant="link"
                    size="sm"
                    disabled={disabled}
                    onClick={() =>
                      change([
                        ...new Set([
                          ...selected,
                          ...rows.filter(s => s.active !== false).map(s => s.id)
                        ])
                      ])
                    }
                  >
                    Select all{search ? ' shown' : ''}
                  </Button>
                  <Button
                    type="button"
                    variant="link"
                    size="sm"
                    disabled={disabled}
                    onClick={() =>
                      change(
                        selected.filter(id => !rows.some(s => s.id === id))
                      )
                    }
                  >
                    None
                  </Button>
                </span>
              )}
            </div>
            {rows.map(store => (
              <Form.Check
                key={store.id}
                id={`${id}-${store.id}`}
                type={multiple ? 'checkbox' : 'radio'}
                name={id}
                className="mb-2"
                disabled={disabled}
                checked={selected.includes(store.id)}
                onChange={e =>
                  change(
                    multiple
                      ? e.target.checked
                        ? [...selected, store.id]
                        : selected.filter(id => id !== store.id)
                      : [store.id]
                  )
                }
                label={
                  <span>
                    <span className="d-inline-flex align-items-center gap-2">
                      <BrandIcon
                        src={marketplaceIconFor(
                          store.marketplaceName,
                          store.storeName || store.label
                        )}
                        alt={`${store.label} (${
                          store.marketplaceName || 'Store'
                        })`}
                        size={18}
                      />
                      <span>{store.label}</span>
                    </span>{' '}
                    {store.marketplaceName && (
                      <Badge bg="light" text="dark">
                        {store.marketplaceName}
                      </Badge>
                    )}
                    {store.active === false && (
                      <Badge bg="secondary" className="ms-2">
                        Inactive
                      </Badge>
                    )}
                  </span>
                }
              />
            ))}
          </div>
        ))}
        {!visible.length && (
          <p className="small text-muted">No stores match this search.</p>
        )}
      </div>
    </div>
  );
};
export default StoreChecklist;
